/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Presets_None_TitleInputs */



/**
* | output |
* | --- |
* | "No Presets Available" |
*
* @param {Transcript_Export_Presets_None_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_presets_none_title = /** @type {((inputs?: Transcript_Export_Presets_None_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Presets_None_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun prereglage disponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Voreinstellungen verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun preset disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предустановки отсутствуют")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ajustes preestablecidos disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无预设可用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットは利用できません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्रीसेट उपलब्ध नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma predefinição disponível")
	return /** @type {LocalizedString} */ ("No Presets Available")
});